export const INPUT_VALUE_VALIDATOR = /^$|^[\n\u0020-\u007E\u00A0-\u02AF\u20A0-\u20BF]+$/;

export const FILE_NAME_VALIDATOR = /^[\u0020-\u007E\u00A0-\u02AF\u20A0-\u20BF]+$/;

export const EMAIL_VALIDATOR = /^[\w.%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const POSTAL_CODE_VALIDATOR = /^[a-zA-Z0-9 'àâçéèêëîïôûùüÿ\-)(]+$/;
export const POSTAL_CODE_SANITIZER = /[^a-zA-Z0-9 'àâçéèêëîïôûùüÿ\-)(]+/;
